// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  battleId: __t.u64().name("battle_id"),
  suppression: __t.f32(),
  cover: __t.f32(),
  fatigue: __t.f32(),
  injuryTier: __t.u32().name("injury_tier"),
  fitForDutyAt: __t.timestamp().name("fit_for_duty_at"),
  lastFireAt: __t.timestamp().name("last_fire_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
